/**
 * Get common offset parent of elements.
 */
import getOffsetParent from "./getOffsetParent"

const getCommonOffsetContainer = (element: Element, otherElement: Element) => {
  const isFollowing =
    element.compareDocumentPosition(otherElement) &
    Node.DOCUMENT_POSITION_FOLLOWING
  const range = document.createRange()
  const start = isFollowing ? element : otherElement
  const end = isFollowing ? otherElement : element
  range.setStart(start, 0)
  range.setEnd(end, 0)
  const commonAncestorContainer = range.commonAncestorContainer as HTMLElement

  return isOffsetContainer(commonAncestorContainer)
    ? commonAncestorContainer
    : getOffsetParent(commonAncestorContainer)
}

const isOffsetContainer = (element: HTMLElement) => {
  const { nodeName } = element
  if (nodeName === "BODY") {
    return false
  }
  return (
    nodeName === "HTML" ||
    getOffsetParent(element.firstElementChild as HTMLElement) === element
  )
}

export default getCommonOffsetContainer
